var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRideDrivers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8C5 6.34315 6.34315 5 8 5H32C33.6569 5 35 6.34315 35 8V28C35 29.6569 33.6569 31 32 31H8C6.34315 31 5 29.6569 5 28V8Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9C14.4772 9 10 13.4772 10 19C10 24.5228 14.4772 29 20 29C25.5228 29 30 24.5228 30 19C30 13.4772 25.5228 9 20 9ZM20 11.2C23.9 11.2 27.1 14.1 27.7 17.8H23.5C23.1 16.5 21.7 15.6 20 15.6C18.3 15.6 16.9 16.5 16.5 17.8H12.3C12.9 14.1 16.1 11.2 20 11.2ZM12.2 20.2H16.5C16.8 21.2 17.8 22 19 22.3V26.7C15.8 26.4 13.2 23.7 12.2 20.2ZM21 26.7V22.3C22.2 22 23.2 21.2 23.5 20.2H27.8C26.8 23.7 24.2 26.4 21 26.7ZM20 20.5C19.1716 20.5 18.5 19.8284 18.5 19C18.5 18.1716 19.1716 17.5 20 17.5C20.8284 17.5 21.5 18.1716 21.5 19C21.5 19.8284 20.8284 20.5 20 20.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRideDrivers);
export default __webpack_public_path__ + "static/media/ic_ride_drivers.c660e351d80aa200224812be437ca362.svg";
export { ForwardRef as ReactComponent };